/**
 * Profile learning-content tab.
 */
import React from "react";
import { Box } from "@mui/material";

import ProfileContentAssign from "./profile.content.assign";
import ProfileContentDone from "./profile.content.done";

/**
 * Hosts assigned and completed course lists.
 */
const ProfileContent = () => {
  return (
    <Box className="p-4">
      <ProfileContentAssign />
      <ProfileContentDone />
    </Box>
  );
};

export default ProfileContent;
